<form class="login-form" (submit)="onSubmit($event)">
  <dx-form [formData]="formData" [disabled]="loading">

    <dxi-item dataField="email" editorType="dxTextBox"
      [editorOptions]="{ stylingMode: 'filled', mode: 'text', buttons: [{ name: 'user', location: 'before', options: { icon: 'user' } }] }">
      <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>      
      <dxo-label [visible]="false"></dxo-label>
    </dxi-item>

    <dxi-item 
  dataField="password" 
  editorType="dxTextBox" 
  [editorOptions]="passwordEditorOptions">
  <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
  <dxo-label [visible]="false"></dxo-label>
</dxi-item>



    

    <dxi-item itemType="button">
      <dxo-button-options width="100%" type="default" [useSubmitBehavior]="true" [template]="'signInTemplate'">
      </dxo-button-options>
    </dxi-item>

<ng-container *dxTemplate="let item of 'signInTemplate'">
  <div>
    <span class="dx-button-text">
      <ng-container *ngIf="loading; else notLoading">
        <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
      </ng-container>
      <ng-template #notLoading>
        <i class="dx-icon dx-icon-key"></i>
      </ng-template>
    </span>
  </div>
</ng-container>

  </dx-form>
</form>
